import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderRateFilterEntity } from '../../domain/entities/OrderRateFilterEntity'

export class OrderRateFilterModel extends OrderRateFilterEntity {
  userId?: string
  fromDate?: string
  toDate?: string
  userOrderRateReasonId?: number
  branchId?: number
  regionId?: number
  driverId?: number
  constructor(dataDto: OrderRateFilterEntity) {
    super()
    mapEntityProperties<OrderRateFilterModel>(this, dataDto, {
      exclude: ['user', 'date'],
      map: {
        userId: dataDto.user?.id,
        fromDate: dataDto.date ? dataDto.date[0] : undefined,
        toDate: dataDto.date ? dataDto.date[1] : undefined,
        userOrderRateReasonId: dataDto.userOrderRateReason?.id,
        branchId: dataDto.branch?.id,
        regionId: dataDto.region?.id,
        driverId: dataDto.driver?.id
      }
    })
  }
}
